import { render, staticRenderFns } from "./rep-waiting-alert.vue?vue&type=template&id=1dfcb054&"
import script from "./rep-waiting-alert.vue?vue&type=script&lang=js&"
export * from "./rep-waiting-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports